
export default (eventName, data) => {
    const event = new Event(eventName);
    event.data = data;
    document.dispatchEvent(event);
}
